(() => {
  const form = document.querySelector('#RNCartForm');
  if (!form) return;
  const updateButton = form.querySelector('[data-rn-cart-update]');
  let timer;
  const queueUpdate = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      form.setAttribute('aria-busy', 'true');
      if (form.requestSubmit && updateButton) form.requestSubmit(updateButton);
      else form.submit();
    }, 350);
  };
  form.querySelectorAll('[data-rn-cart-item]').forEach((item) => {
    const input = item.querySelector('[data-rn-quantity-input]');
    if (!input) return;
    item.querySelector('[data-rn-quantity-minus]')?.addEventListener('click', () => {
      input.value = Math.max(0, Number(input.value || 0) - 1);
      queueUpdate();
    });
    item.querySelector('[data-rn-quantity-plus]')?.addEventListener('click', () => {
      input.value = Number(input.value || 0) + 1;
      queueUpdate();
    });
    input.addEventListener('change', () => {
      input.value = Math.max(0, Number(input.value || 0));
      queueUpdate();
    });
  });
})();